import { render, staticRenderFns } from "./ZhYmp.vue?vue&type=template&id=bb353878&scoped=true"
import script from "./ZhYmp.vue?vue&type=script&lang=js"
export * from "./ZhYmp.vue?vue&type=script&lang=js"
import style0 from "./ZhYmp.vue?vue&type=style&index=0&id=bb353878&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb353878",
  null
  
)

export default component.exports